import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  checkbox: {
    '&.MuiCheckbox-root': {
      padding: '0 8px 0 0',

      '& svg': {
        fill: theme.new.color.border,
        width: '20px',
        height: '20px',
      },
    },

    '&.Mui-checked': {
      '& .MuiSvgIcon-root': {
        fill: theme.new.color.brandPrimary,
      },
    },

    '&.Mui-disabled': {
      '& .MuiSvgIcon-root': {
        fill: theme.new.color.textTertiary,
      },
    },
  },
  showHideColumnsButton: {
    borderRadius: '8px',
    border: `1px solid ${theme.new.color.line.border}`,
    height: '48px',
    minWidth: 'unset',
    width: '48px',

    '&:hover': {
      backgroundColor: theme.new.color.brand[100],
    },

    '&.active': {
      backgroundColor: theme.new.color.brand[100],
    },

    '.MuiButton-startIcon': {
      margin: 0,
    },
  },
  popoverContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: 16,
  },
  checkboxWrapper: {
    '&:focus-within:has(:focus-visible)': {
      border: `2px solid ${theme.new.color.brand[500]}`,
      borderRadius: '4px',
      marginLeft: '-4px',
      padding: '2px',
    },
  },
  checkboxWrapperDraggable: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'default',
  },
  dragHandle: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
    opacity: 0.6,
    marginLeft: '8px',
    '&:hover': {
      opacity: 1,
    },
    '&:active': {
      cursor: 'grabbing',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    },
  },
}));

export default useStyles;
